<template>
  <div class="page-wrap">
    <div class="panel-card">

      <!-- Header -->
      <div class="panel-header">
        <div class="panel-header__icon"><i class="fa fa-envelope-o"></i></div>
        <div class="panel-header__text">
          <div class="panel-header__title">Email Templates</div>
          <div class="panel-header__sub">Manage email and SMS notification templates</div>
        </div>
      </div>

      <!-- Loading -->
      <div class="state-box" v-if="dataLoading">
        <div class="state-spinner"></div>
        <span>Loading templates…</span>
      </div>

      <!-- Editors -->
      <div class="editors-wrap" v-else>

        <div class="editor-section">
          <div class="editor-section__header">
            <div class="editor-section__icon"><i class="fa fa-user"></i></div>
            <div>
              <div class="editor-section__title">Applicant Template</div>
              <div class="editor-section__sub">Sent to applicants upon appointment confirmation</div>
            </div>
          </div>
          <div class="editor-section__body">
            <editor api-key="no-api-key" v-model="emailtemplete" :init="config"
              tinymce-script-src="/tinymce/js/tinymce/tinymce.min.js" />
          </div>
        </div>

        <div class="editor-section">
          <div class="editor-section__header">
            <div class="editor-section__icon"><i class="fa fa-briefcase"></i></div>
            <div>
              <div class="editor-section__title">Job Template</div>
              <div class="editor-section__sub">Sent for mobile job registration invitations</div>
            </div>
          </div>
          <div class="editor-section__body">
            <jobeditor api-key="no-api-key" v-model="jobtemplate" :init="job_config"
              tinymce-script-src="/tinymce/js/tinymce/tinymce.min.js" />
          </div>
        </div>

        <div class="editor-section">
          <div class="editor-section__header">
            <div class="editor-section__icon"><i class="fa fa-shield"></i></div>
            <div>
              <div class="editor-section__title">ATF Email Template</div>
              <div class="editor-section__sub">Sent for ATF-related notifications</div>
            </div>
          </div>
          <div class="editor-section__body">
            <emailotpeditor api-key="no-api-key" v-model="atfemailtemplate" :init="atf_email_config"
              tinymce-script-src="/tinymce/js/tinymce/tinymce.min.js" />
          </div>
        </div>

        <div class="editor-section">
          <div class="editor-section__header">
            <div class="editor-section__icon"><i class="fa fa-lock"></i></div>
            <div>
              <div class="editor-section__title">Email OTP Template</div>
              <div class="editor-section__sub">Contains the one-time password for email verification</div>
            </div>
          </div>
          <div class="editor-section__body">
            <emailotpeditor api-key="no-api-key" v-model="emailotptemplate" :init="email_otp_config"
              tinymce-script-src="/tinymce/js/tinymce/tinymce.min.js" />
          </div>
        </div>

        <div class="editor-section">
          <div class="editor-section__header">
            <div class="editor-section__icon"><i class="fa fa-mobile"></i></div>
            <div>
              <div class="editor-section__title">SMS OTP Template</div>
              <div class="editor-section__sub">Contains the one-time password for SMS verification</div>
            </div>
          </div>
          <div class="editor-section__body">
            <smsotpeditor api-key="no-api-key" v-model="smsotptemplate" :init="sms_otp_config"
              tinymce-script-src="/tinymce/js/tinymce/tinymce.min.js" />
          </div>
        </div>

        <div class="editor-section">
          <div class="editor-section__header">
            <div class="editor-section__icon"><i class="fa fa-certificate"></i></div>
            <div>
              <div class="editor-section__title">Apostille Template</div>
              <div class="editor-section__sub">Sent for apostille document requests</div>
            </div>
          </div>
          <div class="editor-section__body">
            <apostilleEditor api-key="no-api-key" v-model="apostilletemplate" :init="apostille_config"
              tinymce-script-src="/tinymce/js/tinymce/tinymce.min.js" />
          </div>
        </div>

        <div class="editor-section editor-section--last">
          <div class="editor-section__header">
            <div class="editor-section__icon"><i class="fa fa-star-o"></i></div>
            <div>
              <div class="editor-section__title">Review Template</div>
              <div class="editor-section__sub">Sent to request applicant reviews after service</div>
            </div>
          </div>
          <div class="editor-section__body">
            <reviewEditor api-key="no-api-key" v-model="reviewtemplate" :init="review_config"
              tinymce-script-src="/tinymce/js/tinymce/tinymce.min.js" />
          </div>
        </div>

      </div>
    </div>

    <!-- Floating save bar -->
    <div class="save-bar" v-if="!dataLoading">
      <span class="save-bar__hint">
        <i class="fa fa-info-circle"></i> Changes are saved when you click Update
      </span>
      <button class="save-bar__update" ref="kt_update_note" @click="updateEmailTemplete()">
        <i class="fa fa-save"></i> Update
      </button>
    </div>
  </div>
</template>
<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { SET_BREADCRUMB } from "@/core/services/store/mutations.type";
import {
  FETCH_EMAIL_TEMPLETE,
  UPDATE_EMAIL_TEMPLETE
} from "@/core/services/store/actions.type";
import Editor from "@tinymce/tinymce-vue";

export default {
  components: {
    editor: Editor,
    jobeditor: Editor,
    emailotpeditor: Editor,
    smsotpeditor: Editor,
    apostilleEditor: Editor,
    reviewEditor: Editor,
  },
  name: "app",
  data() {
    return {
      breadCrumbs: [
        {
          id: 1,
          title: "Dashboard",
          route: "client.dashboard"
        },
        {
          id: 2,
          title: "Setting",
          route: ""
        },
        {
          id: 3,
          title: "Email Template",
          route: ""
        }
      ],
      editor: ClassicEditor,
      jobeditor: ClassicEditor,
      emailotpeditor: ClassicEditor,
      smsotpeditor: ClassicEditor,

      emailtemplete: "",
      emailotptemplate: "",
      smsotptemplate: "",
      jobtemplate: "",
      atfemailtemplate: "",
      dataLoading: true,

      apostilletemplate: "",
      reviewtemplate: "",

      id: 0,
      config: {
        license_key: 'gpl',
        height: 500,
        plugins: [
          "advlist autolink lists link image charmap print preview anchor",
          "searchreplace visualblocks code fullscreen",
          "insertdatetime media table paste code help wordcount"
        ],
        toolbar:
          "undo redo | formatselect | fontsizeselect |bold italic backcolor | \
           alignleft aligncenter alignright alignjustify | \
           bullist numlist outdent indent | removeformat | code | help",
        fontsize_formats:
          "8pt 9pt 10pt 11pt 12pt 14pt 18pt 24pt 30pt 36pt 48pt 60pt 72pt 96pt",
        menubar: "custom",
        menu: {
          custom: {
            title: `<button class="btn btn-success dropdown">Applicant template <i class="menu-icon flaticon2-down"></i></button>`,
            items:
              "appid appicantname applicantphone clientfulladdress sdate showcontact scheduletime servicename findlocation serviceprovider"
          }
        },
        setup: function(editor) {
          editor.ui.registry.addMenuItem("appicantname", {
            text: "Applicant name",
            onAction: function() {
              editor.insertContent("{applicant_full_name}");
            }
          });
          editor.ui.registry.addMenuItem("findlocation", {
            text: "Find location",
            onAction: function() {
              editor.insertContent(`<a href="https://www.google.com/maps/place/{lat},{long}"
                                    style="background-color:#ffbe00; border:1px solid #FFBE00; border-color:#ffbe00; border-radius:0px;
                                    border-width:1px; color:#ffffff; display:inline-block; font-size:14px; font-weight:normal;
                                    letter-spacing:0px; line-height:normal; padding:12px 40px 12px 40px;
                                    text-align:center; text-decoration:none; border-style:solid; font-family:inherit;"
                                    target="_blank">Find
                                    our
                                    location
                                    on
                                    map</a>`);
            }
          });

          editor.ui.registry.addMenuItem("serviceprovider", {
            text: "Service Provider",
            onAction: function() {
              editor.insertContent("{service_provider}");
            }
          });
          editor.ui.registry.addMenuItem("applicantphone", {
            text: "Applicant phone no",
            onAction: function() {
              editor.insertContent("{applicant_phone}");
            }
          });

          editor.ui.registry.addMenuItem("appid", {
            text: "Applicant Id",
            onAction: function() {
              editor.insertContent("{app_id}");
            }
          });

          editor.ui.registry.addMenuItem("clientfulladdress", {
            text: "Location full address",
            onAction: function() {
              editor.insertContent("{client_full_address}");
            }
          });
          editor.ui.registry.addMenuItem("sdate", {
            text: "Schedule date",
            onAction: function() {
              editor.insertContent("{s_date}");
            }
          });
          editor.ui.registry.addMenuItem("showcontact", {
            text: "Location contact",
            onAction: function() {
              editor.insertContent("{client_show_contact}");
            }
          });
          editor.ui.registry.addMenuItem("scheduletime", {
            text: "Schedule time",
            onAction: function() {
              editor.insertContent("{schedule_time}");
            }
          });
          editor.ui.registry.addMenuItem("servicename", {
            text: "Service name",
            onAction: function() {
              editor.insertContent("{service_name}");
            }
          });
        }
      },
      atf_email_config: {
        license_key: 'gpl',
        height: 500,
        plugins: [
          "advlist autolink lists link image charmap print preview anchor",
          "searchreplace visualblocks code fullscreen",
          "insertdatetime media table paste code help wordcount"
        ],
        toolbar:
          "undo redo | formatselect | fontsizeselect |bold italic backcolor | \
           alignleft aligncenter alignright alignjustify | \
           bullist numlist outdent indent | removeformat | code | help",
        fontsize_formats:
          "8pt 9pt 10pt 11pt 12pt 14pt 18pt 24pt 30pt 36pt 48pt 60pt 72pt 96pt",
        menubar: "custom",
        menu: {
          custom: {
            title: `<button class="btn btn-success dropdown">ATF template <i class="menu-icon flaticon2-down"></i></button>`,
            items:
              "appicantname clientfulladdress showcontact servicename serviceprovider"
          }
        },
        setup: function(editor) {
          editor.ui.registry.addMenuItem("appicantname", {
            text: "Applicant name",
            onAction: function() {
              editor.insertContent("{applicant_full_name}");
            }
          });

          editor.ui.registry.addMenuItem("serviceprovider", {
            text: "Service Provider",
            onAction: function() {
              editor.insertContent("{service_provider}");
            }
          });

          editor.ui.registry.addMenuItem("clientfulladdress", {
            text: "Location full address",
            onAction: function() {
              editor.insertContent("{client_full_address}");
            }
          });

          editor.ui.registry.addMenuItem("showcontact", {
            text: "Location contact",
            onAction: function() {
              editor.insertContent("{client_show_contact}");
            }
          });

          editor.ui.registry.addMenuItem("servicename", {
            text: "Service name",
            onAction: function() {
              editor.insertContent("{service_name}");
            }
          });
        }
      },
      job_config: {
        license_key: 'gpl',
        height: 500,
        plugins: [
          "advlist autolink lists link image charmap print preview anchor",
          "searchreplace visualblocks code fullscreen",
          "insertdatetime media table paste code help wordcount"
        ],
        toolbar:
          "undo redo | formatselect | fontsizeselect |bold italic backcolor | \
             alignleft aligncenter alignright alignjustify | \
             bullist numlist outdent indent | removeformat | code | help",
        fontsize_formats:
          "8pt 9pt 10pt 11pt 12pt 14pt 18pt 24pt 30pt 36pt 48pt 60pt 72pt 96pt",
        menubar: "custom",
        menu: {
          custom: {
            title: `<button class="btn btn-success dropdown">Job template <i class="menu-icon flaticon2-down"></i></button>`,
            items:
              "clientname joblink sdate showcontact scheduletime servicename serviceprovider"
          }
        },
        setup: function(jobeditor) {
          jobeditor.ui.registry.addMenuItem("clientname", {
            text: "Client name",
            onAction: function() {
              jobeditor.insertContent("{client_name}");
            }
          });

          jobeditor.ui.registry.addMenuItem("joblink", {
            text: "Registration Link",
            onAction: function() {
              jobeditor.insertContent(`<a href="{link}"
                                    style="background-color:#ffbe00; border:1px solid #FFBE00; border-color:#ffbe00; border-radius:0px;
                                    border-width:1px; color:#ffffff; display:inline-block; font-size:14px; font-weight:normal;
                                    letter-spacing:0px; line-height:normal; padding:12px 40px 12px 40px;
                                    text-align:center; text-decoration:none; border-style:solid; font-family:inherit;"
                                    target="_blank">Register Here</a>`);
            }
          });
          jobeditor.ui.registry.addMenuItem("sdate", {
            text: "Schedule date",
            onAction: function() {
              jobeditor.insertContent("{s_date}");
            }
          });
          jobeditor.ui.registry.addMenuItem("showcontact", {
            text: "Location contact",
            onAction: function() {
              jobeditor.insertContent("{client_show_contact}");
            }
          });
          jobeditor.ui.registry.addMenuItem("scheduletime", {
            text: "Schedule time",
            onAction: function() {
              jobeditor.insertContent("{schedule_time}");
            }
          });
          jobeditor.ui.registry.addMenuItem("servicename", {
            text: "Service name",
            onAction: function() {
              jobeditor.insertContent("{service_name}");
            }
          });
        }
      },
      email_otp_config: {
        license_key: 'gpl',
        height: 500,
        plugins: [
          "advlist autolink lists link image charmap print preview anchor",
          "searchreplace visualblocks code fullscreen",
          "insertdatetime media table paste code help wordcount"
        ],
        toolbar:
          "undo redo | formatselect | fontsizeselect |bold italic backcolor | \
             alignleft aligncenter alignright alignjustify | \
             bullist numlist outdent indent | removeformat | code | help",
        fontsize_formats:
          "8pt 9pt 10pt 11pt 12pt 14pt 18pt 24pt 30pt 36pt 48pt 60pt 72pt 96pt",
        menubar: "custom",
        menu: {
          custom: {
            title: `<button class="btn btn-success dropdown">Email OTP template <i class="menu-icon flaticon2-down"></i></button>`,
            items: "otp locationname serviceprovider"
          }
        },
        setup: function(emailotpeditor) {
          emailotpeditor.ui.registry.addMenuItem("otp", {
            text: "OTP",
            onAction: function() {
              emailotpeditor.insertContent("{otp}");
            }
          });

          emailotpeditor.ui.registry.addMenuItem("locationname", {
            text: "Location Name",
            onAction: function() {
              emailotpeditor.insertContent("{locationname}");
            }
          });
          emailotpeditor.ui.registry.addMenuItem("serviceprovider", {
            text: "Service Provider",
            onAction: function() {
              emailotpeditor.insertContent("{serviceprovider}");
            }
          });
        }
      },
      sms_otp_config: {
        license_key: 'gpl',
        height: 500,
        plugins: [
          "advlist autolink lists link image charmap print preview anchor",
          "searchreplace visualblocks code fullscreen",
          "insertdatetime media table paste code help wordcount"
        ],
        toolbar:
          "undo redo | formatselect | fontsizeselect |bold italic backcolor | \
             alignleft aligncenter alignright alignjustify | \
             bullist numlist outdent indent | removeformat | code | help",
        fontsize_formats:
          "8pt 9pt 10pt 11pt 12pt 14pt 18pt 24pt 30pt 36pt 48pt 60pt 72pt 96pt",
        menubar: "custom",
        menu: {
          custom: {
            title: `<button class="btn btn-success dropdown">SMS OTP template <i class="menu-icon flaticon2-down"></i></button>`,
            items: "otp locationname serviceprovider"
          }
        },
        setup: function(smsotpeditor) {
          smsotpeditor.ui.registry.addMenuItem("otp", {
            text: "OTP",
            onAction: function() {
              smsotpeditor.insertContent("{otp}");
            }
          });

          smsotpeditor.ui.registry.addMenuItem("locationname", {
            text: "Location Name",
            onAction: function() {
              smsotpeditor.insertContent("{locationname}");
            }
          });
          smsotpeditor.ui.registry.addMenuItem("serviceprovider", {
            text: "Service Provider",
            onAction: function() {
              smsotpeditor.insertContent("{serviceprovider}");
            }
          });
        }
      },
      apostille_config: {
        license_key: 'gpl',
        height: 500,
        plugins: [
          "advlist autolink lists link image charmap print preview anchor",
          "searchreplace visualblocks code fullscreen",
          "insertdatetime media table paste code help wordcount"
        ],
        toolbar:
          "undo redo | formatselect | fontsizeselect |bold italic backcolor | \
           alignleft aligncenter alignright alignjustify | \
           bullist numlist outdent indent | removeformat | code | help",
        fontsize_formats:
          "8pt 9pt 10pt 11pt 12pt 14pt 18pt 24pt 30pt 36pt 48pt 60pt 72pt 96pt",
        menubar: "custom",
        menu: {
          custom: {
            title: `<button class="btn btn-success dropdown">Apostille template <i class="menu-icon flaticon2-down"></i></button>`,
            items:
              "client_full_address app_id client service_provider service_name applicant_full_name applicant_phone client_show_contact lat long s_date schedule_time"
          }
        },
        setup: function(editor) {
          editor.ui.registry.addMenuItem("client_full_address", {
            text: "Client Full Address",
            onAction: function() {
              editor.insertContent("{client_full_address}");
            }
          });
          editor.ui.registry.addMenuItem("app_id", {
            text: "Applicant ID",
            onAction: function() {
              editor.insertContent("{app_id}");
            }
          });
          editor.ui.registry.addMenuItem("client", {
            text: "Client",
            onAction: function() {
              editor.insertContent("{client}");
            }
          });
          editor.ui.registry.addMenuItem("service_provider", {
            text: "Service Provider",
            onAction: function() {
              editor.insertContent("{service_provider}");
            }
          });
          editor.ui.registry.addMenuItem("service_name", {
            text: "Service Name",
            onAction: function() {
              editor.insertContent("{service_name}");
            }
          });
          editor.ui.registry.addMenuItem("applicant_full_name", {
            text: "Applicant Full Name",
            onAction: function() {
              editor.insertContent("{applicant_full_name}");
            }
          });
          editor.ui.registry.addMenuItem("applicant_phone", {
            text: "Applicant Phone No.",
            onAction: function() {
              editor.insertContent("{applicant_phone}");
            }
          });
          editor.ui.registry.addMenuItem("client_show_contact", {
            text: "Client Show Contact",
            onAction: function() {
              editor.insertContent("{client_show_contact}");
            }
          });
          editor.ui.registry.addMenuItem("lat", {
            text: "Latitude",
            onAction: function() {
              editor.insertContent("{lat}");
            }
          });
          editor.ui.registry.addMenuItem("long", {
            text: "Longitude",
            onAction: function() {
              editor.insertContent("{long}");
            }
          });
          editor.ui.registry.addMenuItem("s_date", {
            text: "Schedule Date",
            onAction: function() {
              editor.insertContent("{s_date}");
            }
          });
          editor.ui.registry.addMenuItem("schedule_time", {
            text: "Schedule Time",
            onAction: function() {
              editor.insertContent("{schedule_time}");
            }
          });
        }
      },
      review_config: {
        license_key: 'gpl',
        height: 500,
        plugins: [
          "advlist autolink lists link image charmap print preview anchor",
          "searchreplace visualblocks code fullscreen",
          "insertdatetime media table paste code help wordcount"
        ],
        toolbar:
          "undo redo | formatselect | fontsizeselect |bold italic backcolor | \
           alignleft aligncenter alignright alignjustify | \
           bullist numlist outdent indent | removeformat | code | help",
        fontsize_formats:
          "8pt 9pt 10pt 11pt 12pt 14pt 18pt 24pt 30pt 36pt 48pt 60pt 72pt 96pt",
        menubar: "custom",
        menu: {
          custom: {
            title: `<button class="btn btn-success dropdown">Review template <i class="menu-icon flaticon2-down"></i></button>`,
            items:
              "applicant_full_name service_provider_name location_name url location_full_address location_contact service_name"
          }
        },
        setup: function(editor) {
          editor.ui.registry.addMenuItem("applicant_full_name", {
            text: "Applicant Full Name",
            onAction: function() {
              editor.insertContent("{applicant_full_name}");
            }
          });
          editor.ui.registry.addMenuItem("service_provider_name", {
            text: "Service Provider Name",
            onAction: function() {
              editor.insertContent("{service_provider_name}");
            }
          });
          editor.ui.registry.addMenuItem("location_name", {
            text: "Location Name",
            onAction: function() {
              editor.insertContent("{location_name}");
            }
          });
          editor.ui.registry.addMenuItem("url", {
            text: "URL",
            onAction: function() {
              editor.insertContent("{url}");
            }
          });
          editor.ui.registry.addMenuItem("location_full_address", {
            text: "Location full address",
            onAction: function() {
              editor.insertContent("{location_full_address}");
            }
          });
          editor.ui.registry.addMenuItem("location_contact", {
            text: "Location contact",
            onAction: function() {
              editor.insertContent("{location_contact}");
            }
          });
          editor.ui.registry.addMenuItem("service_name", {
            text: "Service Name",
            onAction: function() {
              editor.insertContent("{service_name}");
            }
          });
        }
      },
    };
  },
  created() {
    this.$store.commit(SET_BREADCRUMB, this.breadCrumbs);
    this.getEmailTemplete();
  },

  methods: {
    getEmailTemplete() {
      this.dataLoading = false;
      this.$store
        .dispatch(FETCH_EMAIL_TEMPLETE)
        .then(res => {
          var data = res.data;
          this.id = data.id ? data.id : 0;

          this.emailtemplete = data.applicant_template;
          this.jobtemplate = data.job_template;
          this.smsotptemplate = data.sms_otp_template;
          this.apostilletemplate = data.apostille_template;
          this.reviewtemplate = data.review_template;
          this.emailotptemplate = data.email_otp_template;
          this.atfemailtemplate = data.atf_template;
          this.dataLoading = false;
        })
        .catch(() => {
          this.dataLoading = false;
        });
    },
    updateEmailTemplete() {
      const submitButton = this.$refs["kt_update_note"];
      submitButton.disabled = true;
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");
      var data = {
        form_data: {
          applicant_template: this.emailtemplete,
          job_template: this.jobtemplate,
          sms_otp_template: this.smsotptemplate,
          email_otp_template: this.emailotptemplate,
          atf_template: this.atfemailtemplate,
          apostille_template: this.apostilletemplate,
          review_template: this.reviewtemplate,
        },
        id: this.id
      };
      this.$store
        .dispatch(UPDATE_EMAIL_TEMPLETE, data)
        .then(res => {
          this.id = res.i_id;
          this.$toastr.s(res.msg);
          this.getEmailTemplete();
          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
          submitButton.disabled = false;
        })
        .catch(err => {
          this.$toastr.e(err.msg);
          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
          submitButton.disabled = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
$font:   'Segoe UI', sans-serif;
$blue:   #389ad4;
$dark:   #0d1b3e;
$border: #dde2ec;

@keyframes spin { to { transform: rotate(360deg); } }

.page-wrap {
  padding: 12px 12px 96px;
  font-family: $font;
}

/* ── panel card ── */
.panel-card {
  background: #fff;
  border: 1px solid $border;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
}

/* ── header ── */
.panel-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px 24px;
  border-bottom: 1px solid $border;
  background: linear-gradient(135deg, #f8faff 0%, #f0f5ff 100%);

  &__icon {
    width: 48px; height: 48px; border-radius: 12px;
    background: linear-gradient(135deg, $blue, #2277aa);
    display: flex; align-items: center; justify-content: center;
    color: #fff; font-size: 18px; flex-shrink: 0;
  }
  &__text { flex: 1; }
  &__title { font-size: 16px; font-weight: 700; color: $dark; line-height: 1.2; }
  &__sub   { font-size: 12px; color: #7a8499; margin-top: 3px; }
}

/* ── state box ── */
.state-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 56px 24px;
  gap: 8px;
  color: #7a8499;
  font-size: 13px;
  font-family: $font;
}

.state-spinner {
  width: 32px; height: 32px;
  border: 3px solid #c5d8f5;
  border-top-color: $blue;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
  margin-bottom: 8px;
}

/* ── editors wrap ── */
.editors-wrap {
  padding: 0;
}

/* ── editor section ── */
.editor-section {
  border-bottom: 1px solid $border;
  padding: 24px 28px;

  &--last { border-bottom: none; }

  &__header {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    margin-bottom: 14px;
  }

  &__icon {
    width: 34px; height: 34px;
    border-radius: 8px;
    background: rgba(56,154,212,0.1);
    color: $blue;
    display: flex; align-items: center; justify-content: center;
    font-size: 14px;
    flex-shrink: 0;
    margin-top: 1px;
  }

  &__title {
    font-size: 14px;
    font-weight: 700;
    color: $dark;
    line-height: 1.3;
  }

  &__sub {
    font-size: 12px;
    color: #7a8499;
    margin-top: 2px;
  }

  &__body {
    border: 1.5px solid $border;
    border-radius: 10px;
    overflow: hidden;
  }
}

/* ── floating save bar ── */
.save-bar {
  position: fixed;
  bottom: 2.5rem;
  width: calc(78vw);
  left: 50%;
  transform: translateX(-40%);
  background: #1a2340;
  border-radius: 14px;
  padding: 14px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 8px 32px rgba(13,27,62,0.3);
  z-index: 100;

  &__hint {
    display: flex;
    align-items: center;
    gap: 7px;
    font-size: 12px;
    color: rgba(255,255,255,0.55);
    font-family: $font;
    i { font-size: 12px; }
  }

  &__update {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    background: $blue;
    color: #fff;
    border: none;
    border-radius: 9px;
    padding: 9px 22px;
    font-size: 13px;
    font-weight: 600;
    font-family: $font;
    cursor: pointer;
    transition: background 0.15s, box-shadow 0.15s;

    &:hover { background: #2d85bb; box-shadow: 0 4px 14px rgba(56,154,212,0.4); }
    &:disabled { opacity: 0.6; cursor: default; box-shadow: none; }
  }
}
</style>
